module.exports = __webpack_public_path__ + "static/media/thumbnail.1ec8ef34.jpg";